
import styled from "styled-components";
import { palette } from "styled-theme";
import { transition, borderRadius } from "@iso/lib/helpers/style_utils";
import WithDirection from "@iso/lib/helpers/rtl";

const SidebarWrapper = styled.div`
.close{
  display:none;
}

  .isomorphicSidebar {
    z-index: 1000;
    background: #2A4A3A;
    // width: 240px !important;
    flex: 0 0 280px;
max-width: none !important;
min-width : none !important;
    .scrollarea {
      height: calc(100vh - 70px);
    }
  //   a#custom-menu-icon svg path {
  //     stroke:black;
  // }
    @media only screen and (max-width: 767px) {
      width: 240px !important;
      flex: 0 0 240px !important;
    }

    @media only screen and (max-width: 480px) {
      width: 375px !important;
      min-width: 375px !important;
      max-width: 375px !important;
      flex: 0 0 375px !important;
    }

    &.ant-layout-sider-collapsed {
      @media only screen and (max-width: 767px) {
        width: 0;
        min-width: 0 !important;
        max-width: 0 !important;
        flex: 0 0 0 !important;
      }
    }
    /* Collapse control lives at the BOTTOM of the sidebar (Figma): a full-width
       bar with a divider on top and a centred chevron. In normal flow (after the
       scroll area, which reserves its 48px) so the sidebar fills to the bottom. */
    .collapseBar {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background: #2A4A3A;
      border-top: 1px solid rgba(255, 255, 255, 0.12);
      color: rgba(255, 255, 255, 0.7);
      ${transition()};
      &:hover {
        color: #ffffff;
      }
      @media only screen and (max-width: 767px) {
        display: none;
      }
    }
    .isoLogoWrapper {
      border-bottom: 1px solid rgba(255, 255, 255, 0.12);
      height: 70px;
      background: #2A4A3A;
      margin: 0;
      padding: 0 10px;
      text-align: center;
      overflow: hidden;
      ${borderRadius()};

      img {
        /* Invert the green wordmark to white so it reads on the green bar. */
        filter: brightness(0) invert(1);
      }

      h3 {
        a {
          font-size: 21px;
          font-weight: 300;
          line-height: 70px;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: ${palette("grayscale", 6)};
          display: block;
          text-decoration: none;
        }
      }
    }

    &.ant-layout-sider-collapsed {
      .isoLogoWrapper {
        padding: 0;

        h3 {
          a {
            font-size: 27px;
            font-weight: 500;
            letter-spacing: 0;
          }
        }
      }
    }

  

    .isoDashboardMenu {
      padding-top: 35px;
      padding-bottom: 35px;
      background: transparent;

      a {
        text-decoration: none;
        font-weight: 400;
      }
  

      .ant-menu-item {
        width: 100%;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
        padding: 0 24px;
        margin: 0;
      }

      /* The Menu runs with inlineIndent={0}, so rc-menu adds no per-level
         indent. Pin every item AND every group header to the same 24px, so
         dropdown children line up flush with the top-level property item and
         their own section header — no nesting indent. */
      .ant-menu-item,
      .ant-menu-submenu-title {
        padding-left: 24px !important;
      }

      .isoMenuHolder {
        display: flex  !important;
        align-items: center !important;

        span.nav-text:hover {
          color: #ffffff !important;
        }
        color: #cfdcd4;
        i {
          font-size: 19px;
          color: inherit;
          margin: ${(props) =>
    props["data-rtl"] === "rtl" ? "0 0 0 30px" : "0 30px 0 0"};
          width: 18px;
          ${transition()};
        }
      }

      
     
      .anticon {
        font-size: 18px;
        margin-right: 30px;
        color: inherit;
        ${transition()};
      }

      .nav-text {
        font-size: 14px;
        color: #cfdcd4;
        font-weight: 400;
        ${transition()};
      }

      /* Collapsible group headers (Operations / Management / Farm / Safety /
         People / Monitor) — styled as section titles with a chevron. */
      .ant-menu-submenu.nav-group > .ant-menu-submenu-title {
        color: rgba(255, 255, 255, 0.55);
        font-size: 11px;
        font-weight: 600;
        letter-spacing: 1px;
        text-transform: uppercase;
        height: 36px;
        line-height: 36px;
        margin: 8px 0 0;
        padding-left: 24px !important;
        &:hover {
          color: #ffffff;
          .ant-menu-submenu-arrow:before,
          .ant-menu-submenu-arrow:after {
            background: #ffffff;
          }
        }
      }
      .ant-menu-submenu.nav-group > .ant-menu-submenu-title .ant-menu-submenu-arrow:before,
      .ant-menu-submenu.nav-group > .ant-menu-submenu-title .ant-menu-submenu-arrow:after {
        background: rgba(255, 255, 255, 0.55);
      }

      /* antd indents a submenu's child items one level deeper than the
         submenu title. Zero the nested <ul> and pin the child items to the
         SAME 24px as the header (high specificity to beat antd's inline
         indent) so a module's icon starts exactly under the header text. */
      .ant-menu-submenu.nav-group > .ant-menu-sub {
        padding-left: 0 !important;
        margin-left: 0 !important;
      }
      .ant-menu-submenu.nav-group > .ant-menu-sub > .ant-menu-item {
        padding-left: 24px !important;
      }
      .ant-menu-submenu.nav-group > .ant-menu-sub > .ant-menu-item-selected {
        padding-left: 16px !important;
      }

      .sidebar-icon svg path {
        stroke: #cfdcd4;
        ${transition()};
      }
      li:hover .sidebar-icon svg path {
        stroke: #ffffff;
      }

      /* Keep selected-item text white (antd otherwise colours it with the
         theme primary green, which is unreadable on the green sidebar). */
      .ant-menu-item-selected,
      .ant-menu-item-selected a,
      .ant-menu-item-selected .nav-text,
      .ant-menu-item-selected .isoMenuHolder .nav-text,
      .ant-menu-submenu-selected > .ant-menu-submenu-title,
      .ant-menu-submenu-selected > .ant-menu-submenu-title .nav-text {
        color: #ffffff !important;
      }

      .ant-menu-item-selected {
        /* Figma: inset rounded rectangle + straight white bar at the sidebar's
           left edge (drawn via ::before so the bar stays square while the
           highlight corners round). */
        background: rgba(255, 255, 255, 0.12) !important;
        border-radius: 8px !important;
        margin: 0 8px !important;
        width: calc(100% - 16px) !important;
        padding: 0 16px !important;
        position: relative;
        overflow: visible;
        &::before {
          content: '';
          position: absolute;
          left: -8px;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 22px;
          border-radius: 0;
          background: #ffffff;
        }
        &::after {
          display: none; /* antd's default right-edge indicator */
        }
        .sidebar-icon svg path {
          stroke: #ffffff !important;
        }
        @media only screen and (max-width: 480px) {
          background-color: transparent !important;
          border-right: none;
        }
        span.ant-menu-title-content {
          @media only screen and (max-width: 480px) {
            background-color: #f7f9f6 !important;
            padding-left: 15px;
            padding-right: 15px;
            border-radius: 10px;
          }
        }
        .anticon {
          color: #fff;
        }

        i {
          color: #fff;
        }

        .nav-text {
          color: #ffffff;
          @media only screen and (max-width: 480px) {
            color: #8f9497;
          }
        }
        .sidebar-icon {

          svg {

            path {
              @media only screen and (max-width: 480px) {
                fill: unset;
                rgb(143, 148, 151) !important;
              }
            }
          }
        }
      }

      /* Items inside the group dropdowns: antd indents children via an inline
         padding-left (48px); flatten it so items hug the left edge exactly
         like the old top-level items (24px), 16px when selected so the 8px
         inset margin keeps the text aligned. */
      .ant-menu-sub .ant-menu-item {
        padding-left: 24px !important;
      }
      .ant-menu-sub .ant-menu-item-selected {
        padding-left: 16px !important;
      }

      > li {
        &:hover {
          i,
          .nav-text {
            color: #ffffff;
            @media only screen and (max-width: 480px) {
              color: #ffffff !important;
            }
          }
        }
      }
    }

    /* Group dropdown panels stay on the sidebar green (antd dark theme would
       otherwise give them their own darker panel colour). */
    .ant-menu-dark .ant-menu-inline.ant-menu-sub {
      background: transparent !important;
      box-shadow: none;
    }

  //   .gHEeuw .isomorphicSidebar .ant-menu-item: a {
  //     color: rgb(143, 148, 151) !important;
  // }
    .ant-menu-item {
      span.ant-menu-title-content {
        @media only screen and (max-width: 480px) {
          padding-left: 15px;
          padding-right: 15px;
        }
      }
      &:hover {
        a {
          color: #ffffff !important;
          .isoMenuHolder {
            .nav-text {
              color: #ffffff !important;
              @media only screen and (max-width: 480px) {
                color: #ffffff !important;
              }
            }
          }

        }
      }
    }
    .ant-menu-item.ant-menu-item-selected {
      &:hover {
        a {
          color: #ffffff !important;
          .isoMenuHolder {
            .nav-text {
              color: #ffffff !important;
              @media only screen and (max-width: 480px) {
                color: #ffffff !important;
              }
            }
          }
        }
      }
    }
    .ant-menu-submenu-inline,
    .ant-menu-submenu-vertical {
      > .ant-menu-submenu-title {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 0 24px;

        > span {
          display: flex;
          align-items: center;
        }

        .ant-menu-submenu-arrow {
          left: ${(props) => (props["data-rtl"] === "rtl" ? "25px" : "auto")};
          right: ${(props) => (props["data-rtl"] === "rtl" ? "auto" : "25px")};

          &:before,
          &:after {
            width: 8px;
            ${transition()};
          }

          &:before {
            transform: rotate(-45deg) translateX(3px);
          }

          &:after {
            transform: rotate(45deg) translateX(-3px);
          }

          ${"" /* &:after {
            content: '\f123';
            font-family: 'Ionicons' !important;
            font-size: 16px;
            color: inherit;
            left: ${props => (props['data-rtl'] === 'rtl' ? '16px' : 'auto')};
            right: ${props => (props['data-rtl'] === 'rtl' ? 'auto' : '16px')};
            ${transition()};
          } */
  };
        }

        &:hover {
          .ant-menu-submenu-arrow {
            &:before,
            &:after {
              color: #ffffff;
            }
          }
        }
      }

      .ant-menu-inline,
      .ant-menu-submenu-vertical {
        > li:not(.ant-menu-item-group) {
          padding-left: ${(props) =>
    props["data-rtl"] === "rtl" ? "0px !important" : "74px !important"};
          padding-right: ${(props) =>
    props["data-rtl"] === "rtl" ? "74px !important" : "0px !important"};
          font-size: 13px;
          font-weight: 400;
          margin: 0;
          color: inherit;
          ${transition()};

          &:hover {
            a {
              color: #ffffff !important;
            }
          }
        }

        .ant-menu-item-group {
          padding-left: 0;

          .ant-menu-item-group-title {
            padding-left: 100px !important;
          }
          .ant-menu-item-group-list {
            .ant-menu-item {
              padding-left: 125px !important;
            }
          }
        }
      }

      .ant-menu-sub {
        box-shadow: none;
        background-color: transparent !important;
        .ant-menu-item a {
          color: #cfdcd4;
        }
        .ant-menu-item a:hover,
        .ant-menu-item-selected a {
          color: #ffffff;
        }
      }
    }

    &.ant-layout-sider-collapsed {
      .nav-text {
        display: none;
      }

      .ant-menu-submenu-inline > {
        .ant-menu-submenu-title:after {
          display: none;
        }
      }

      .ant-menu-submenu-vertical {
        > .ant-menu-submenu-title:after {
          display: none;
        }

        .ant-menu-sub {
          background-color: transparent !important;

          .ant-menu-item {
            height: 35px;
          }
        }
      }
    }
  .mailmainBox{
    width:  47.968px;
            height: 45px;
            margin-left: 90px;
            border-radius: 16px;
            background-color: #0B2A1B !important;
            z-index : 1;
            position : relative;
 
  }
  .subDivBox{
    margin-top:-20px;
    margin-left:22px;
    margin-bottom:10px;
    width: 180.865px;
    height: 180px;
    flex-shrink: 0;
    border-radius: 24px;
    // opacity:  0.04999999701976776;
    background-color: rgba(247, 249, 246, 1);

    
  }
  .infoBox{

    

    padding-top: 40px;
    padding-left: 30px;
   
               width: 150.897px;
              color: var(--black-b-100, #171717);
              text-align: center;
              font-family: DM Sans;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: 22px; /* 137.5% */
              letter-spacing: -0.4px;

        .pro{
          font-family: DM Sans;
    font-size: 16px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: -0.4000000059604645px;
    text-align: center;
        }
  }
  .infoBtn{
    margin: 20px;
    width: 140.897px;
    height: 40px;
    flex-shrink: 0;
    border-radius: 8px;
    border: none;
    color:white;
    background-color: var(--table-title, #0B2A1B );
  }
  .arrowImg{
    margin:10px;
    width: 23.984px;
height: 24px;
flex-shrink: 0;
  }
  @media only screen and (max-width: 480px) {
    .isomorphicSidebar .isoLogoWrapper{
      width:180px !important;
    }
    .isomorphicSidebar.ant-layout-sider-collapsed .isoLogoWrapper{
      width:auto !important;
    }
  .triggerBtn{
    display:block !important;
    right:20px !important;
    top:24px;
  }
}
`;

export default WithDirection(SidebarWrapper);
